import birthdayWidget from './birthday-widget';
import buttonLinkWidget from './button-link-widget';
import changePosWidget from './change-pos-widget';
import commerzFinanzRatenrechnerWidget from './commerz-finanz-ratenrechner-widget';
import disableOnClickWidget from './disable-on-click-widget';
import editableAddressWidget from './editable-address-widget'
import inLayerFormWidget from './in-layer-form-widget';
import messagesWidget from './messages-widget';
import pageinoverlayWidget from './pageinoverlay-widget';
import scrolltopWidget from './scrolltop-widget';
import epDialogWidget from './epdialog-widget';
import overlayWidget from './overlay-widget';
import posSearchWidget from "./pos-search-widget";

export default function(){
	birthdayWidget();
	buttonLinkWidget();
	changePosWidget();
	commerzFinanzRatenrechnerWidget();
	disableOnClickWidget();
	editableAddressWidget();
	epDialogWidget();
	inLayerFormWidget();
	messagesWidget();
	pageinoverlayWidget();
	scrolltopWidget();
}
